import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';

registerLocaleData(localeDe, 'de');

import { BrowserModule } from '@angular/platform-browser';
import { NgModule, Injector } from '@angular/core';
import { HttpClientModule } from "@angular/common/http";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ScrollingModule } from '@angular/cdk/scrolling';
import { createCustomElement } from "@angular/elements";

import { ChatbotLibModule } from './modules/chatbot';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxSliderModule } from 'ngx-slider-v2';
import { AngularSplitModule } from 'angular-split'
import { RangeSliderModule } from './modules/range-slider';

import { ChatBotHostComponent, ChatbotHostService } from './chatbothost';

import {
    MedizinischesCannabisAntragComponent,
    HeaderComponent,
    AccordionComponent,
    SharedComponent,
    LiteratureResearchComponent,
    ResearchPopupComponent,
    ResearchCardsComponent,
    ResearchCardEditComponent,
    SaveJsonPopupComponent,
    LoadJsonPopupComponent,
    DosageAppPopupComponent,
    ProductPopupComponent,
    ProductDosageComponent,
    ApothekenReservierungComponent,
    ICDCodeFinderComponent,
    FooterComponent,
    QuestionsInfoComponent,
    QuestOptionsComponent,
    QuestionFeedbackComponent,
    FeedbackWebinarComponent,
    InhalativOralComponent,
    THCCBDGroupComponent,
    THCCBDCardsComponent,
    MedikamenteQuestionComponent,
    TitrationsplanComponent,
    TitrationsplanPpopupComponent
} from './medizinisches-cannabisantrag';

import { DocCheckLoginComponent } from './doc-check-login';
import {
    TitrationRechnerComponent,
    TitrationRechnerInfoComponent,
    TitrationRezeptComponent,
    TitrationTherapieStartenComponent,
    TitrationTherapieFortsetzenComponent,
    TitrationTherapieCommonComponent,
    TitrationRechnerPopupComponent
} from './titration-rechner';

import { AntragFeedbackComponent } from './antrag-feedback';

import { SymptommatrixComponent, SymptommatrixService } from './symptommatrix'

import {
    OrderByPipe,
    FilterByPipe,
    GroupByPipe
} from './pipes';

import { SharedService } from './shared';

const medizinisComponent = [
    MedizinischesCannabisAntragComponent,
    HeaderComponent,
    AccordionComponent,
    SharedComponent,
    LiteratureResearchComponent,
    ResearchPopupComponent,
    ResearchCardsComponent,
    ResearchCardEditComponent,
    SaveJsonPopupComponent,
    LoadJsonPopupComponent,
    DosageAppPopupComponent,
    ProductPopupComponent,
    ProductDosageComponent,
    ApothekenReservierungComponent,
    ICDCodeFinderComponent,
    FooterComponent,
    QuestionsInfoComponent,
    QuestOptionsComponent,
    QuestionFeedbackComponent,
    FeedbackWebinarComponent,
    InhalativOralComponent,
    THCCBDGroupComponent,
    THCCBDCardsComponent,
    MedikamenteQuestionComponent,
    TitrationsplanComponent,
    TitrationsplanPpopupComponent
]


const otherComponent = [
    ChatBotHostComponent,
    AntragFeedbackComponent,
    SymptommatrixComponent,
    DocCheckLoginComponent,
    TitrationRechnerComponent,
    TitrationRechnerInfoComponent,
    TitrationRezeptComponent,
    TitrationTherapieStartenComponent,
    TitrationTherapieFortsetzenComponent,
    TitrationTherapieCommonComponent,
    TitrationRechnerPopupComponent
]

const pipes = [
    OrderByPipe,
    FilterByPipe,
    GroupByPipe
]

@NgModule({
    declarations: [
        ...medizinisComponent,
        ...otherComponent,
        ...pipes
    ],
    imports: [
        BrowserModule,
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule,
        ScrollingModule,
        ChatbotLibModule,
        NgbModule,
        NgxSliderModule,
        AngularSplitModule,
        RangeSliderModule
    ],
    providers: [
        SharedService,
        ChatbotHostService,
        SymptommatrixService,
        ...pipes
    ]
})
export class AppModule {
    constructor(private injector: Injector) { }

    ngDoBootstrap() {
        const chatBotHostElement = createCustomElement(ChatBotHostComponent, {
            injector: this.injector
        });
        customElements.define("chat-bot-host-element", chatBotHostElement);

        const MedizinischesCannabisAntragHostElement = createCustomElement(MedizinischesCannabisAntragComponent, {
            injector: this.injector
        });
        customElements.define("medizinisches-cannabisantrag-host-element", MedizinischesCannabisAntragHostElement);

        const AntragFeedbackHostElement = createCustomElement(AntragFeedbackComponent, {
            injector: this.injector
        });
        customElements.define("antrag-feedback-host-element", AntragFeedbackHostElement);


        const SymptommatrixElement = createCustomElement(SymptommatrixComponent, {
            injector: this.injector
        });
        customElements.define("symptom-matrix-host-element", SymptommatrixElement);

        const DocCheckLoginHostElement = createCustomElement(DocCheckLoginComponent, {
            injector: this.injector
        });
        customElements.define("doc-check-login-host-element", DocCheckLoginHostElement);

        const TitrationRechnerHostElement = createCustomElement(TitrationRechnerComponent, {
            injector: this.injector
        });
        customElements.define("titration-rechner-host-element", TitrationRechnerHostElement);
    }
}
